
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Client } from '@/types/client';

interface BillingSectionProps {
  form: UseFormReturn<Client>;
}

export const BillingSection: React.FC<BillingSectionProps> = ({ form }) => {
  return (
    <div className="bg-white p-6 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-montserrat font-semibold text-primary-700 mb-4 flex items-center">
        <div className="w-2 h-2 bg-primary-500 rounded-full mr-2" />
        Configurações de Cobrança
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="due_day"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Dia de Vencimento</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  type="number"
                  min="1"
                  max="31"
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="10"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="send_pix"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border border-gray-200 p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-gray-700 font-medium">Enviar PIX</FormLabel>
                <div className="text-sm text-gray-500">
                  Ativar envio de PIX para cobrança
                </div>
              </div>
              <FormControl>
                <Switch
                  checked={field.value ?? false}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
